import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Tooltip } from 'react-tooltip';
import configApi from '../../config';

const LostRevenue = () => {
    const [noShowTracker, setNoShowTracker] = useState({
        estimatedLostRevenue: 0,
        totalNoShows: 0
    });
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        axios.get(`${configApi.apiEndpoint}/api/Stats/DashboardContext`, config)
            .then(response => {
                const nsTracking = response.data.noShowTracking || response.data.NoShowTracking || {};
                setNoShowTracker({
                    estimatedLostRevenue: nsTracking.estimatedLostRevenue || nsTracking.EstimatedLostRevenue || 0,
                    totalNoShows: nsTracking.totalNoShows || nsTracking.TotalNoShows || 0
                });
                setIsLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the lost revenue:', error);
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div className="metric-card w-100 h-100">
                <div className="skeleton-circle"></div>
                <div className="metric-data gap-2">
                    <div className="skeleton-box" style={{ width: '80px', height: '28px' }}></div>
                    <div className="skeleton-box" style={{ width: '120px', height: '14px' }}></div>
                </div>
            </div>
        );
    }

    return (
        <div className="metric-card w-100 h-100">
            <div className="metric-icon" style={{ backgroundColor: '#ffcdd2', color: '#d32f2f' }}>
                <i className="bi bi-graph-down-arrow"></i>
            </div>
            <div className="metric-data">
                <h3 className="fw-bold m-0 text-dark">
                    {new Intl.NumberFormat('sk-SK').format(noShowTracker.estimatedLostRevenue)} €
                </h3>
                <span
                    className="text-muted"
                    style={{ fontSize: '0.85rem', cursor: 'help', borderBottom: '1px dotted #ccc' }}
                    data-tooltip-id="lost-rev-tooltip"
                    data-tooltip-content={`Odhadovaný ušlý zisk z celkového počtu ${noShowTracker.totalNoShows} nezúčastnených (Prepadlo) termínov.`}
                >
                    Ušlý zisk (Storná)
                </span>
            </div>
            <Tooltip id="lost-rev-tooltip" place="top" effect="solid" />
        </div>
    );
};

export default LostRevenue;
